import {
    List,
    Datagrid,
    TextField,
    NumberField,
    ImageField,
    EditButton,
    useRecordContext,
    Filter,
    TextInput,
    FunctionField,
} from 'react-admin';
import FormattedDateTimeField from "../../common/FormattedDateTimeField";
import ReactAudioPlayer from 'react-audio-player';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

function fixComponent<T>(component: T): T {
    return (component as any).default ?? component;
}
const ReactAudioPlayerComponent = fixComponent(ReactAudioPlayer);

export const AudioPlayback = () => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <ReactAudioPlayerComponent
            src={record.url}
            autoPlay={false}
            controls
            controlsList="nodownload"
        />
    );
};

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="title" alwaysOn />
    </Filter>
);

const PodcastList = () => {
    const { isUpdatable, isDeletable, isWritable } = useIsPermission("PODCAST");
    return (
        <List
            filters={<ListFilter />}
            actions={<PermissionBasedActions isWritable={isWritable} />}
            sort={{ field: 'display_order', order: 'ASC' }}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <Datagrid>
                <ImageField source="thumbnail" />
                <TextField source="title" sortable={false} />
                <NumberField source="displayOrder" sortable={false} />

                <FunctionField
                    label="Audio"
                    render={() => <AudioPlayback />}
                />
                <FormattedDateTimeField source="createdAt" sortable={false} />
                {isUpdatable && <EditButton />}
                {isDeletable && <ConfirmDeleteButton />}
            </Datagrid>
        </List>
    );
};

export default PodcastList;
